module.exports = __webpack_public_path__ + "static/media/sales-stream-panel-open.ca984990.svg";